import { AddressSummaryFormZA } from '@/components/slides/DataSummary/za/SummaryForms/AddressSummaryFormZA';
import { AncestrySummaryFormZA } from '@/components/slides/DataSummary/za/SummaryForms/AncestrySummaryFormZA';
import { ContactSummaryFormZA } from '@/components/slides/DataSummary/za/SummaryForms/ContactSummaryFormZA';
import { NameSummaryFormZA } from '@/components/slides/DataSummary/za/SummaryForms/NameSummaryFormZA';
import { PersonalInfoSummaryFormZA } from '@/components/slides/DataSummary/za/SummaryForms/PersonalInfoSummaryFormZA';

export const SummaryFormsZA = () => {
  return (
    <>
      <NameSummaryFormZA />
      <ContactSummaryFormZA />
      <AddressSummaryFormZA />
      <PersonalInfoSummaryFormZA />
      <AncestrySummaryFormZA />
    </>
  );
};
